import * as React from 'react';

function SvgPause(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M25 5h-4.5a1 1 0 00-1 1v20a1 1 0 001 1H25a1 1 0 001-1V6a1 1 0 00-1-1zM11.5 5H7a1 1 0 00-1 1v20a1 1 0 001 1h4.5a1 1 0 001-1V6a1 1 0 00-1-1z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgPause;
